import {GET, POST, PATCH, POST_FILE} from './http';

const query = values => new URLSearchParams(Object.entries(values).filter(([, value]) => value !== '' && value !== null && value !== undefined)).toString();

export const Equipment = (token, search = '', limit = 20) => GET(`pm-labeling/equipment?${query({search, limit})}`, token);
export const Technicians = token => GET('pm-labeling/technicians', token);
export const Printers = token => GET('pm-labeling/printers', token);
export const Preview = (token, data) => POST('pm-labeling/preview', data, token);
export const Print = (token, data) => POST('pm-labeling/print', data, token);
export const History = (token, filters = {}) => GET(`pm-labeling/history?${query(filters)}`, token);
export const AdminCatalog = token => GET('pm-labeling/admin/catalog', token);
export const CreateEquipment = (token, data) => POST('pm-labeling/admin/equipment', data, token);
export const UpdateEquipment = (token, id, data) => PATCH(`pm-labeling/admin/equipment/${id}`, data, token);
export const CreateTechnician = (token, data) => POST('pm-labeling/admin/technicians', data, token);
export const UpdateTechnician = (token, id, data) => PATCH(`pm-labeling/admin/technicians/${id}`, data, token);
export const CreatePrinter = (token, data) => POST('pm-labeling/admin/printers', data, token);
export const UpdatePrinter = (token, id, data) => PATCH(`pm-labeling/admin/printers/${id}`, data, token);
export const UploadTemplate = (token, data) => POST_FILE('pm-labeling/admin/templates', data, token);
